module.exports = __webpack_public_path__ + "img/payToMaster.c97acca3.png";